import configureStore from "./store/configureStore";

const store = configureStore();

export default store;
